"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryControlContainer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c70b34881{display:block}.c032d3d78{padding-left:.6875rem;display:block;font-size:.875rem;font-weight:400;line-height:1.25rem;color:var(--color-flomni-gray-70);padding-top:.25rem}.ce561c64f .c032d3d78{color:var(--color-flomni-rose-70)}.cea3ff72e .c032d3d78{opacity:.4;color:var(--color-flomni-gray-70)}");
var styles = {
  root: 'c70b34881',
  label: 'c032d3d78',
  '--warning': 'ce561c64f',
  '--disabled': 'cea3ff72e'
};

var PrimaryControlContainer = function PrimaryControlContainer(props, ref) {
  var children = props.children,
      warning = props.warning,
      label = props.label,
      disabled = props.disabled,
      classes = props.classes,
      labelProps = props.labelProps;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.warning, !!warning), (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, children, !warning && !label ? null : /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({
    className: cn.label
  }, labelProps), warning || label));
};

exports.PrimaryControlContainer = PrimaryControlContainer;
PrimaryControlContainer.propTypes = {
  /* component logic props */
  label: _propTypes.string,
  warning: _propTypes.string,
  disabled: _propTypes.bool,
  children: _propTypes.node.isRequired,
  labelProps: _propTypes.object,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryControlContainer.defaultProps = {
  label: null,
  warning: null,
  disabled: false,
  classes: {},
  labelProps: {}
};